const types = {
  SET_CREDIT: "SET_CREDIT",
  SET_SOLICITATION: "SET_SOLICITATION",
  SET_SELECTED_FIRST_CITY: "SET_SELECTED_FIRST_CITY",
  SET_SELECTED_FIRST_STATE: "SET_SELECTED_FIRST_STATE",
  SET_SELECTED_SECOND_CITY: "SET_SELECTED_SECOND_CITY",
  SET_SELECTED_SECOND_STATE: "SET_SELECTED_SECOND_STATE",
  SET_SELECTED_FIRST_RELATIONSHIP: "SET_SELECTED_FIRST_RELATIONSHIP",
  SET_SELECTED_SECOND_RELATIONSHIP: "SET_SELECTED_SECOND_RELATIONSHIP",
  SET_PERSONAL: "SET_PERSONAL",
  SET_FAMILY: "SET_FAMILY",
  SET_SELECTED_FAMILY_FIRST_STATE: "SET_SELECTED_FAMILY_FIRST_STATE",
  SET_SELECTED_FAMILY_FIRST_CITY: "SET_SELECTED_FAMILY_FIRST_CITY",
  SET_SELECTED_FAMILY_FIRST_RELATIONSHIP: "SET_SELECTED_FAMILY_FIRST_RELATIONSHIP",
  SET_SELECTED_FAMILY_SECOND_STATE: "SET_SELECTED_FAMILY_SECOND_STATE",
  SET_SELECTED_FAMILY_SECOND_CITY: "SET_SELECTED_FAMILY_SECOND_CITY",
  SET_SELECTED_FAMILY_SECOND_RELATIONSHIP: "SET_SELECTED_FAMILY_SECOND_RELATIONSHIP"
}

export default types
